import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=57f80af7&scoped=true"
import script from "./Factory.vue?vue&type=script&lang=js"
export * from "./Factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f80af7",
  null
  
)

export default component.exports